<template>
  <div>
    <!-- 搜索表单 -->
    <el-form ref="form" :model="query" inline size="mini" label-width="100px">
      <el-form-item label="设备编码">
        <el-input v-model="query.eqpUuid" clearable placeholder="请输入设备SN码"></el-input>
        <!-- <el-input v-model="query.snStart" clearable placeholder="请输入设备SN码"></el-input>
       -
        <el-input v-model="query.snEnd" clearable placeholder="请输入设备SN码"></el-input> -->
      </el-form-item>
      <el-form-item label="设备模式">
        <el-select v-model="query.type" clearable placeholder="请选择设备模式">
          <el-option label="无人" value="1"></el-option>
          <el-option label="滴滴" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="设备状态">
        <el-select v-model="query.binding" clearable placeholder="请选择设备状态">
          <el-option label="已绑定" value="1"></el-option>
          <el-option label="未绑定" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="商家信息">
        <el-input v-model="query.merchant" clearable placeholder="请输入商家信息"></el-input>
      </el-form-item>
      <el-form-item label="房间信息">
        <el-input v-model="query.room" clearable placeholder="请输入房间信息"></el-input>
      </el-form-item>

      <el-button type="primary" size="mini" @click="seach">搜索</el-button>
      <!--<el-button type="danger" @click="addDialogVisible = true" size="mini">添加设备</el-button>-->
      <!-- <el-button type="warning" @click="tongbu(1)" size="mini">同步无人</el-button>
      <el-button type="warning" @click="tongbu(2)" size="mini">同步滴滴</el-button> -->
      <el-button type="warning" @click="tongbu(3)" size="mini">同步设备</el-button>
    </el-form>
    <!-- 卡片视图 -->
    <el-card class="box-card">
      <!-- 展开行数据展示 -->
      <el-table :data="deviceList"  style="width: 100%" height="650px" border="" stripe>
        <!-- 表格数据展示区域 -->
        <el-table-column label="设备SN码">
          <template slot-scope="scope">
            <div class="uuidBox" @click="createdQrcode(scope.row.uuid)">
              <i class="el-icon-camera" style="padding-right: 5px;"></i>
              <el-popover placement="right" width="164" trigger="click">
                <img :src="qrCodeUrl">{{scope.row.uuid}}
                <span slot="reference">{{scope.row.uuid}}</span>
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="factory" label="设备Factory"></el-table-column>
        <el-table-column label="模式" width="70">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.type === 1" type="warning">无人</el-tag>
            <el-tag v-if="scope.row.type === 2" type="danger">滴滴</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="70">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.startup">在线</el-tag>
            <el-tag type="info" v-else>离线</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="merchantName" label="商家名称"></el-table-column>
        <el-table-column prop="roomName" label="房间名称"></el-table-column>

        <el-table-column label="操作" width="350">
          <template slot-scope="scope">
            <!-- <el-tooltip effect="dark" content="绑定记录" placement="bottom-start">
              <el-button type="info" icon="el-icon-connection" size="mini" @click="lookRecord(scope.row.uuid)"></el-button>
            </el-tooltip> -->
            <el-button type="danger" size="small" @click="tongdian(scope.row.uuid, 1)">上电测试</el-button>
            <el-button type="danger" size="small" @click="tongdian(scope.row.uuid, 2)">断电测试</el-button>
            <el-button type="danger" size="small" @click="unbinding(scope.row.uuid)">强制解绑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="CurrentPageChange"
        :current-page="query.curPage"
        :page-sizes="[5, 10, 15]"
        :page-size="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>
    <!-- 绑定记录数据展示框 -->
    <el-dialog title="设备绑定记录" :visible.sync="recordDialogVisible" width="80%">
      <el-table :data="bindRecord" style="width: 100%" border="" stripe>
        <el-table-column prop="createTime" label="变更时间"></el-table-column>
        <el-table-column label="变更类型">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.bindingType === 1">代理变更</el-tag>
            <el-tag type="warning" v-else>商家变更</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
        <el-table-column prop="beforeBindingUuid" label="变更前代理ID"></el-table-column>
        <el-table-column prop="beforeBindingName" label="变更前代理名称"></el-table-column>
        <el-table-column prop="beforeBindingCellphone" label="变更前代理号码"></el-table-column>
        <el-table-column prop="afterBindingUuid" label="变更后代理ID"></el-table-column>
        <el-table-column prop="afterBindingName" label="变更后代理名称"></el-table-column>
        <el-table-column prop="afterBindingCellphone" label="变更后代理号码"></el-table-column>
      </el-table>
    </el-dialog>
    <!-- 添加表单 -->
    <el-dialog title="添加设备" :visible.sync="addDialogVisible" width="40%">
      <div>
        <el-form ref="addRef" :model="addForm" :rules="addRules" label-width="100px" label-position="left">

          <el-form-item label="设备SN码" prop="uuid" v-if="addForm.model == 1">
            <el-input v-model="addForm.uuid"></el-input>
          </el-form-item>
          <el-form-item label="设备模式" prop="type">
            <el-select v-model="addForm.type" clearable placeholder="请选择设备模式">
              <el-option label="无人" value="1"></el-option>
              <el-option label="滴滴" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="设备工厂" prop="type">
            <el-select v-model="addForm.factory" clearable placeholder="请选择设备工厂">
              <el-option label="雀家无人" value="hdo7RV1Mr5r"></el-option>
              <el-option label="雀家滴滴" value="hdo7mjmMw35"></el-option>
              <el-option label="麻界无人" value="hdo7wewMrGq"></el-option>
              <el-option label="麻界滴滴" value="hdo7OGgBIIE"></el-option>
              <el-option label="OEM无人" value="hdo7XyE5zaF"></el-option>
              <el-option label="OEM滴滴" value="hdo77g7M773"></el-option>
            </el-select>
          </el-form-item>
          <el-button type="primary" @click="add">确定添加</el-button>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { list, recover, add, check, operate } from '@/API/device'
import Qrcode from 'qrcode'
import { baseQR } from '@/base.js'
export default {
  name: 'devices',
  data() {
    return {
      // 设备列表请求参数
      query: {
        curPage: 1,
        pageSize: 10,
        eqpUuid: '',
        binding: '',
        snStart: '',
        snEnd: '',
        ctEnd: '',
        ctStart: ''
      },
      // 时间段
      period1: [],
      period2: [],
      period3: [],
      period4: [],
      // 设备列表数据
      deviceList: [],
      // 数据总条数
      total: 0,
      // 添加
      addDialogVisible: false,
      // 添加设备表单参数
      addForm: {
        model: 1,
        uuid: '',
        type: '1'
      },
      // 添加单个设备表单验证规则
      addRules: {
        uuid: [{ required: true, message: '请输入设备SN码', trigger: 'blur' }],
        type: [{ required: true, message: '请选择设备模式', trigger: 'change' }]
      },
      // 充电柜详情数据
      cabinetInfo: {},
      // 充电柜详情数据对话框是否显示
      cabineDialogTableVisible: false,
      // 充电线详情数据
      lineInfo: [],
      // 充电线密码对话框是否显示
      lineDialogTableVisible: false,
      // 绑定记录数据列表
      bindRecord: [],
      // 绑定数据展示框是否显示
      recordDialogVisible: false,
      // 二维码url地址
      qrCodeUrl: '',
      onlineUpgradeDialogTableVisible: false
    }
  },
  created() {
    this.getDeviceList()
  },
  methods: {
    async getDeviceList() {
      const { data: res } = await list(this.query)
      if (res.code !== 200) return this.$message.error(res.message)
      this.deviceList = res.data.entities
      this.total = res.data.totalSize
    },
    // 搜索按钮点击触发
    seach() {
      this.query.curPage = 1
      if (this.period1 != null && this.period1 !== []) {
        this.query.ctStart = this.period1[0]
        this.query.ctEnd = this.period1[1]
      } else {
        this.query.ctStart = ''
        this.query.ctEnd = ''
      }
      this.getDeviceList()
    },
    // 重置按钮点击触发
    custody() {
      this.query = {
        curPage: 1,
        pageSize: 10
      }
      this.getDeviceList()
    },
    // 监听pageSize的变化值
    pageSizeChange(newSize) {
      this.query.pageSize = newSize
      this.getDeviceList()
    },
    // 监听currentPage的变化
    CurrentPageChange(newPage) {
      this.query.curPage = newPage
      this.getDeviceList()
    },
    // 设备回拨
    retrieve(eqpUuid) {
      this.$confirm('此操作将回收设备, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          // eslint-disable-next-line no-undef
          const { data: res } = await opreate({ eqpUuid, mode })
          if (res.code !== 200) return this.$message.error(res.message)
          this.getDeviceList()
          this.$message.success(res.message)
        })
    },
    // 设备回拨
    tongbu(type) {
      this.$confirm('此操作将同步设备, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          const { data: res } = await check({
            type: type
          })
          if (res.code !== 200) return this.$message.error(res.message)
          this.getDeviceList()
          this.$message.success(res.message)
        })
    },
    //
    tongdian(eqpUuid, mode) {
      let a = '上电'
      if (mode !== 1) {
        a = '断电'
      }
      this.$confirm('此操作将' + a + '设备, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: res } = await operate({ eqpUuid, mode })
        if (res.code !== 200) {
          return this.$message.error(res.message)
        } else {
          this.$message.success(res.message)
        }
      })
    },
    unbinding(eqpUuid) {
      this.$confirm('此操作将强制解绑设备, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: res } = await recover({ eqpUuid })
        if (res.code !== 200) {
          return this.$message.error(res.message)
        } else {
          this.getDeviceList()
          this.$message.success(res.message)
        }
      })
    },
    // 点击设备SN码生成二维码
    createdQrcode(data) {
      let shareUrl = baseQR + 'Agounet/anmonp?MID=' + data
      Qrcode.toDataURL(shareUrl).then(Url => {
        this.qrCodeUrl = Url
        this.qrcodeDialogTableVisible = true
      })
    },
    // 单个添加
    add() {
      this.$refs.addRef.validate(async valid => {
        if (!valid) return
        if (this.addForm.model === 1) {
          const { data: res } = await add(this.addForm)
          if (res.code !== 200) return this.$message.error(res.message)
          this.$message.success(res.message)
        } else {
          // eslint-disable-next-line no-undef
          const { data: res } = await batchAdd(this.addForm)
          if (res.code !== 200) return this.$message.error(res.message)
          this.$message.success(res.message)
        }
        this.$refs.addRef.resetFields()
        this.addDialogVisible = false
        this.getDeviceList()
      })
    }
  }
}
</script>

<style lang="less" scoped>
.seachBtn {
  display: inline-block;
  margin-left: 45px;
}
.el-input,
.el-date-picker,
.el-select {
  width: 180px !important;
}
.el-card__body {
  padding: 0;
  .el-form-item {
    margin: 0;
    margin: 0;
    width: 33%;
  }
  .uuidBox {
    position: relative;
    cursor: pointer;
  }
  .el-pagination {
    padding-top: 20px;
  }
}
.el-table-column {
  box-sizing: content-box;
}
.qrcodeBox {
  position: fixed;
  bottom: 100px;
  left: 18px;
  z-index: 99;
}
.visibleBox {
  .el-form {
    .el-form-item {
      margin: 0;
      margin: 0;
      width: 25%;
    }
    .el-button {
      margin-top: 4px;
    }

  }
}
.onlineUpgrade {
    .el-select {
      width: 300px !important;
    }
}
.el-tag {
  margin-left: 3px !important;
}
</style>
